<template>
  <v-dialog v-model="open" @input="v => v || closeDialog()" max-width="500px">
    <v-card>
      <v-card-title>{{ "lng_register_password_new" | translate }}</v-card-title>
      <p class="forgot_password-text">
        {{ "lng_password_info" | translate }}
      </p>
      <v-card-text class="pb-0">
        <v-form ref="setPassword" v-model="valid" lazy-validation>
          <v-text-field
            :label="'lng_user_serial' | translate"
            v-model="currentSerial"
            :rules="serialRules"
            required
            v-on:keyup.enter="submitSetPassword"
          />
          <v-text-field
            :label="'lng_register_password_new' | translate"
            v-model="newPassword"
            type="password"
            :rules="newPasswordRules"
            required
            v-on:keyup.enter="submitSetPassword"
          />
          <v-text-field
            :label="'lng_register_password_new_repeat' | translate"
            v-model="repeatPassword"
            type="password"
            :rules="repeatPasswordRules"
            required
            v-on:keyup.enter="submitSetPassword"
          />
        </v-form>
        <p class="error-text" v-if="error">{{ error }}</p>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="dialog(false)">{{
              "lng_close" | translate
            }}</v-btn>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              :class="[canSubmit ? 'primary-btn' : 'disabled-btn']"
              block
              flex
              xs12
              flat
              :loading="submitting"
              :disabled="!canSubmit"
              @click="submitSetPassword"
              >{{ "lng_submit" | translate }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalService from "../services/global-service.js";
import { translate } from "../common/HelperFunctions.js";

export default {
  name: "SetPasswordDialog",
  data() {
    return {
      open: false,
      valid: true,
      currentSerial: "",
      newPassword: "",
      repeatPassword: "",
      submitting: false,
      error: "",
    };
  },
  props: {
    token: {
      type: String,
      default: "",
    },
    serial: {
      type: String,
      default: "",
    },
    dialog: {
      type: Function,
      default: undefined,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function,
      default: undefined,
    },
  },
  computed: {
    serialRules() {
      return [(v) => !!v || ""];
    },
    newPasswordRules() {
      return [
        (v) => !!v || "",
        (v) => (v && v.length >= 8) || `${translate("lng_password_info")}`,
        (v) =>
          (!!v && v) !== this.currentSerial ||
          `${translate("lng_password_info")}`,
      ];
    },
    repeatPasswordRules() {
      return [
        (v) => !!v || "",
        (v) =>
          (!!v && v) === this.newPassword ||
          `${translate("lng_password_mismatch")}`,
      ];
    },
    canSubmit() {
      return (
        !this.submitting &&
        this.token &&
        this.currentSerial &&
        this.newPassword.length >= 8 &&
        this.newPassword === this.repeatPassword &&
        this.newPassword !== this.currentSerial
      );
    }
  },
  mounted() {
    this.currentSerial = this.serial || "";
  },
  watch: {
    openDialog: function(newVal) {
      this.open = newVal;
      if (newVal) {
        this.error = "";
        this.newPassword = "";
        this.repeatPassword = "";
        this.currentSerial = this.serial || this.currentSerial;
      }
    },
    serial: function(newVal) {
      this.currentSerial = newVal || "";
    }
  },
  methods: {
    closeDialog() {
      this.dialog(false);
    },
    normalizeResponse(response) {
      if (typeof response === "string" && response) {
        return { token: response };
      }
      if (response && typeof response === "object") {
        return response;
      }
      return null;
    },
    isSuccess(response) {
      if (!response) {
        return false;
      }
      const status = response.status;
      const statusOk =
        status === undefined ||
        status === 0 ||
        status === "0" ||
        status === false;
      return statusOk && !!response.token;
    },
    async submitSetPassword() {
      if (this.submitting) {
        return;
      }
      this.error = "";
      if (this.$refs.setPassword && !this.$refs.setPassword.validate()) {
        return;
      }
      if (!this.canSubmit) {
        return;
      }
      this.submitting = true;
      let response;
      try {
        response = this.normalizeResponse(
          await GlobalService.setPassRequest(
            this.token,
            this.currentSerial,
            this.newPassword
          )
        );
      } catch (e) {
        this.submitting = false;
        this.error = "Request Failed! Try again later";
        return;
      }
      this.submitting = false;
      if (this.isSuccess(response)) {
        this.dialog(false);
        this.onSuccess(response, this.currentSerial);
      } else {
        this.error = translate("lng_save_notok");
      }
    }
  }
};
</script>
<style>
.error-text {
  font-size: 14px;
  padding: 0;
  margin: 0 0 8px;
  color: red;
  text-align: center;
}
</style>
